import React from "react";

import Avatars from "@dicebear/avatars";
import SpriteCollection from "@dicebear/avatars-identicon-sprites";

export const avatar = (botId, size, style = {}) => {
  const avatars = new Avatars(SpriteCollection);
  return (
    <span
      style={{ width: size + "px", height: size + "px", display: "inline-block", ...style }}
      dangerouslySetInnerHTML={{ __html: avatars.create(botId) }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/utils/avatar.js